<template>
  <div class="of-box" style="margin-top: 0;margin-left: 0;padding-left: 0;padding-top: 0;">
    <div class="of-container is-vertical base-page-box5">
      <div class="of-aside base-search-box ">
        <div class="of-filter clearfix">
          <div class="filter-left">

          </div>
          <div class="filter-right">
          </div>
        </div>
      </div>
      <div ref="demandtableBox" class="of-main no-scroll">
        <div class="of-table" style="padding:0">
          <el-table v-loading="isloading" border stripe resizable :data="listData"
            style="width: 100%" size="small" :max-height="boxHeight"
            :header-cell-style="{ background: '#f2f3f5' }" tooltip-effect
            :cell-class-name="cellClass">
            <el-table-column v-for="(item, index) in tableCols" :key="index" :prop="item.prop"
              :label="item.label" :width="item.width" header-align="left" :align="item.align">

              <template slot-scope="scope">
                <el-tooltip v-if="item.showtip" placement="bottom" effect="light" trigger="hover"
                  :open-delay="500">
                  <div slot="content" v-html="getcontent(scope.row,item.prop,item.label)">
                  </div>
                  <span>{{ scope.row[item.prop]}}</span>
                </el-tooltip>
                <span v-else>{{scope.row[item.prop] }}</span>
              </template>
            </el-table-column>

            <el-table-column v-for="(item, index) in tableCols2" :key="index" :prop="item.prop"
              :label="item.label" :width="item.width" header-align="left" :align="item.align">

              <template slot-scope="scope">
                <el-tooltip v-if="item.showtip" placement="bottom" effect="light" trigger="hover"
                  :open-delay="500">
                  <div slot="content" v-html="tipContent">
                  </div>
                  <span>{{ scope.row[item.prop]}}</span>
                </el-tooltip>
                <span v-else>{{scope.row[item.prop] }}</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
      <div class="of-aside">
        <my-pagination :total="total" :pageSize="pageQuery.pageSize"
          :pageIndex="pageQuery.pageIndex" @change="pageChange"></my-pagination>
      </div>
    </div>

  </div>
</template>
<script>
import { getQueryDemandList } from '@/modules/contract/api/freightnew.js'
import MyPagination from "@/components/pagination"
export default {
  name: 'DModelPage',
  components: {
    MyPagination
  },
  props: {
    bform: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data () {
    return {
      pageQuery: {
        pageSize: 50,
        pageIndex: 1,
        sortOrder: 'asc',
        sortField: 'DispatchDate,DemandNo,DemandCanNumber',
        fastSearchFields: 'DriverEmployeeName,TowVehicleName',
        fastSearchKeyWord: '',
        ReportRelateId: '',
        Status: '在用',
      },
      issubmit: false,
      boxHeight: 500,
      total: 0,
      tableCols: [
        { label: '计划日期', prop: 'DispatchDate', width: '100', type: '' },
        { label: '趟次开始驻地', prop: 'ResidenceName', width: '100', type: '', showtip: true },
        { label: '装货点', prop: 'LoadingPointName', width: '120', type: '', showtip: true },
        { label: '卸货点', prop: 'UnloadingPointName', width: '120', type: '', showtip: true },
        { label: '货物', prop: 'GoodsName', width: '60', type: '', showtip: true },
        { label: '货物规格', prop: 'GoodsSpecifications', width: '80', type: '', showtip: true },
        { label: '需求数量', prop: 'DemandQty', width: '80', type: '', align: 'right', showtip: true },
        { label: '装货数量(Ton)', prop: 'GoodsTon', width: '120', type: '', align: 'right', showtip: true },
        { label: '装货数量', prop: 'LoadingRealQty', width: '80', type: '', align: 'right', showtip: true },
        { label: '装货密度', prop: 'LoadDensity', width: '80', type: '', align: 'right' },
        { label: '卸货数量', prop: 'UnLoadingRealQty', width: '80', type: '', align: 'right', showtip: true },
        { label: '卸货密度', prop: 'UnLoadDensity', width: '80', type: '', align: 'right' },
        { label: '送货单号', prop: 'DeliveryNumber', width: '100', type: '', },
        { label: '单位', prop: 'Unit', width: '60', type: '', showtip: true, align: 'right' },
        { label: '仓号', prop: 'DemandCanNumber', width: '60', type: '', showtip: true },
        { label: '趟次', prop: 'TowVehicleNum', width: '60', type: '', showtip: true, align: 'right' },
        { label: '设备号码', prop: 'TowVehicleName', width: '80', type: '', showtip: true },
        { label: '设备自编号', prop: 'VehicleSelfNumber', width: '80', type: '', showtip: true },
        { label: '挂车号', prop: 'TrailerVehicleName', width: '80', type: '', showtip: true },
        { label: '驾驶员工号', prop: 'DriverEmployeeNo', width: '100', type: '', showtip: true },
        { label: '驾驶员', prop: 'DriverEmployeeName', width: '80', type: '', showtip: true },
        { label: '押运员', prop: 'EscortEmployeeName', width: '80', type: '', showtip: true },
        { label: '趟次编号', prop: 'DemandTrainNumber', width: '80', type: '', showtip: true },
        { label: '运作顺序', prop: 'TrainNumberSerial', width: '80', type: '', showtip: true, align: 'right' },
        { label: '驻地到装货点里程', prop: 'ReToLoadingMileage', width: '120', type: '', align: 'right' },
        { label: '装货点间里程', prop: 'LoadingToLoadingMileage', width: '100', type: '', align: 'right' },
        { label: '装货点到卸货点里程', prop: 'LoadingToUnLoadingMileage', width: '130', type: '', align: 'right' },
        { label: '卸货点间里程', prop: 'UnLoadingToUnLoadingMileage', width: '100', type: '', align: 'right' },
        { label: '卸货点到装货点/驻地里程', prop: 'TUnLoadingToReMileage', width: '160', type: '', align: 'right' },
        { label: '趟次里程', prop: 'SumMileageV1', width: '80', type: '', align: 'right', showtip: true },
        { label: '运单里程', prop: 'SumMileage1', width: '80', type: '', align: 'right', showtip: true },
        { label: '装货点到卸货点里程', prop: 'SumMileage2', width: '160', type: '', align: 'right', showtip: true },
        { label: '最远双程里程', prop: 'SumMileage3', width: '120', type: '', align: 'right', showtip: true },
        { label: '额外里程', prop: 'SumMileageExt', width: '120', type: '', align: 'right', showtip: true },
        { label: '绕行运距', prop: 'DetourDistance', width: '80', type: '', align: 'right', showtip: true },
      ],
      tableCols2: [],
      myForm: {
        title: "新增轮胎",
        form: {},
      },
      isSubmit: false,
      editshow: false,
      isloading: false,
      listData: [],
      tipContent: ''
    }

  },
  computed: {},
  mounted () {
    if (this.bform) {
      this.pageQuery.ReportRelateId = this.bform.Id
      this.boxHeight = 500
      this.loadPageData()
    }
  },
  methods: {
    loadPageData () {
      this.isloading = true
      getQueryDemandList(this.pageQuery).then(res => {
        this.isloading = false
        if (res.data.Code === 0) {
          this.listData = res.data.Data.rows.map(p => { return { ...p, DispatchDate: this.datetime(p.DispatchDate, 'YYYY-MM-DD') } })
          this.total = res.data.Data.total
          if (this.total > 0 && this.tableCols2.length === 0 && this.listData[0].ComAttrJson) {
            this.tableCols2 = []
            JSON.parse(this.listData[0].ComAttrJson).map(p => {
              if (p.ResultType) {
                this.tableCols2.push({ label: p.Title, prop: p.Attr, width: '100', type: '', align: 'right' })
              }

            })
          }
        }
      })
    },
    cellClass ({ row, column }) {
      if (row && row.ChangeLog) {
        let loglist = JSON.parse(row.ChangeLog)
        let pv = null
        switch (column.property) {
          case 'DemandQty': pv = loglist.find(p => p.Attr === 'DemandQty'); break
          case 'GoodsTon': pv = loglist.find(p => p.Attr === 'GoodsTon'); break
          case 'LoadingRealQty': pv = loglist.find(p => p.Attr === 'LoadingRealQty'); break
          case 'UnLoadingRealQty': pv = loglist.find(p => p.Attr === 'UnLoadingRealQty'); break
          case 'SumMileageV1': pv = loglist.find(p => p.Attr === 'SumMileageV1'); break
          case 'SumMileage1': pv = loglist.find(p => p.Attr === 'SumMileage1'); break
          case 'SumMileage2': pv = loglist.find(p => p.Attr === 'SumMileage2'); break
          case 'SumMileage3': pv = loglist.find(p => p.Attr === 'SumMileage3'); break
          case 'SumMileageExt': pv = loglist.find(p => p.Attr === 'SumMileageExt'); break
        }
        if (pv) {
          return 'text-red'
        }

      }
      return ''

    },
    getcontent (row, attr, title) {
      let ary = []
      if (row) {
        ary.push(`${title}:${row[attr]}`)
      }
      if (row && row.ChangeLog) {
        let loglist = JSON.parse(row.ChangeLog)
        let pv = []
        switch (attr) {
          case 'DemandQty': pv = loglist.filter(p => p.Attr === 'DemandQty'); break
          case 'GoodsTon': pv = loglist.filter(p => p.Attr === 'GoodsTon'); break
          case 'LoadingRealQty': pv = loglist.filter(p => p.Attr === 'LoadingRealQty'); break
          case 'UnLoadingRealQty': pv = loglist.filter(p => p.Attr === 'UnLoadingRealQty'); break
          case 'SumMileageV1': pv = loglist.filter(p => p.Attr === 'SumMileageV1'); break
          case 'SumMileage1': pv = loglist.filter(p => p.Attr === 'SumMileage1'); break
          case 'SumMileage2': pv = loglist.filter(p => p.Attr === 'SumMileage2'); break
          case 'SumMileage3': pv = loglist.filter(p => p.Attr === 'SumMileage3'); break
          case 'SumMileageExt': pv = loglist.filter(p => p.Attr === 'SumMileageExt'); break
        }
        pv.map(p => {
          ary.push(`${p.DateStr} ${p.Actor} ${p.Log}`)
        })
      }
      return ary.join('</br>')
    },

    pageChange (pindex, psize) {
      this.pageQuery.pageSize = psize
      this.pageQuery.pageIndex = pindex
      this.loadPageData()
    },

  }
}
</script>

<style>
.text-red {
  color: #e05415;
}
</style>
